import { createSlice } from "@reduxjs/toolkit";
import { UsersProfilebuilderState } from "./types";
import { fetchUsersForm } from "./users-profilebuilder-thunk";
import { ErrorType } from "@/shared/types";

const initialState: UsersProfilebuilderState = {
    formFields: [],
    formId: "",
    formError: null,
    isFormLoading: false,
    isFormFirstLoad: true
}

const usersProfilebuilderSlice = createSlice({
    name: 'usersProfilebuilder',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
        .addCase(fetchUsersForm.pending, (state) => {
            state.isFormLoading = true
            state.formError = null
        })
        .addCase(fetchUsersForm.fulfilled, (state, action) => {
            state.isFormLoading = false
            state.isFormFirstLoad = false
            state.formError = null
            state.formFields = action.payload.template
            state.formId = action.payload.id
        })
        .addCase(fetchUsersForm.rejected, (state, action) => {
            state.formError = action.payload as ErrorType ?? null
            state.isFormLoading = false
        })
    },
})

export default usersProfilebuilderSlice.reducer